import ClickAwayListener from '@material-ui/core/ClickAwayListener';

// eslint-disable-next-line import/prefer-default-export
export { ClickAwayListener };
